// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pageHead__BtAAvAGpnN h1:has(span[id=_elev_io]){overflow:visible}`, "",{"version":3,"sources":["webpack://./src/app/views/layout/views/dashboard/dashboard.view.module.scss"],"names":[],"mappings":"AAEE,gDACE,gBAAA","sourcesContent":[".pageHead {\n  // Make sure the title element content can overflow when the Elevio helper is present.\n  h1:has(span[id='_elev_io']) {\n    overflow: visible;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageHead": `pageHead__BtAAvAGpnN`
};
export default ___CSS_LOADER_EXPORT___;
